import { render, staticRenderFns } from "./RevisitIndex.vue?vue&type=template&id=2f47e09d&scoped=true&"
import script from "./RevisitIndex.vue?vue&type=script&lang=js&"
export * from "./RevisitIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47e09d",
  null
  
)

export default component.exports